/**
 * @file paddle 客户案例的请求方法
 * @author wanzhongyun
 */

import request from 'superagent';
import baseRequest from '../baseApi';

// 获取客户案例页数据
export const fetchGetCustomerCaseData = (): Promise<request.Response> =>
    baseRequest(
        request.get('/platform/page/data')
            .query({requestUrl: '/paddlecase'})
            .query(window.location.search.slice(1))
    );

// 获取企业案例 全部案例列表 数据
interface IGetEnterpriseCaseListDataParam {
    categoryId?: number;
    page?: string | number;
    industry?: string | number;
    tech?: string | number;
    clickType?: string;
    schoolCaseSort?: string | number;
}

export const fetchGetEnterpriseCaseListData = (params: IGetEnterpriseCaseListDataParam | string = ''): Promise<request.Response> =>
    baseRequest(
        request.get('/platform/paddleorg/paddleCaseList')
            .query(params)
            .query(window.location.search.slice(1))
    );
